import _ from "lodash";

const extractFeatureToggleValue = (featureToggles, toggleName) => {
  const toggleObject = featureToggles.length
    ? featureToggles.filter((obj) => obj.name === toggleName)
    : [{ name: "", enabled: false, percentage: 0 }];

  return toggleObject.length && _.has(toggleObject[0], "enabled")
    ? toggleObject[0].enabled
    : false;
};

export default extractFeatureToggleValue;
